export type ProfessionalSituationValues =
  | 'SALARIE_PRIVE'
  | 'FONCTION_PUBLIQUE'
  | 'INDEPENDANT'
  | 'ETUDIANT'
  | 'RECHERCHE_EMPLOI'
  | 'RETRAITE';

enum PROFESSIONAL_SITUATION {
  SALARIE_PRIVE = 'Salarié·e du privé',
  FONCTION_PUBLIQUE = 'Salarié·e de la fonction publique',
  INDEPENDANT = 'Indépendant·e',
  ETUDIANT = 'Étudiant·e',
  RECHERCHE_EMPLOI = "En recherche d'emploi inscrit·e à France Travail",
  RETRAITE = 'Retraité·e',
}

/** Ordre d'affichage des options dans les formulaires. */
export const professionalSituationOrder: ProfessionalSituationValues[] = [
  'SALARIE_PRIVE',
  'FONCTION_PUBLIQUE',
  'INDEPENDANT',
  'ETUDIANT',
  'RECHERCHE_EMPLOI',
  'RETRAITE',
];

/** Libellé du champ libre associé à chaque situation.
 * `null` signifie qu'aucun champ libre n'est demandé pour cette situation.
 * La valeur saisie est stockée dans `User.organism`. */
export const professionalSituationDetailsLabels: Record<
  ProfessionalSituationValues,
  string | null
> = {
  SALARIE_PRIVE: 'Entreprise',
  FONCTION_PUBLIQUE: 'Organisme',
  INDEPENDANT: 'Précisez votre situation',
  ETUDIANT: 'Établissement',
  RECHERCHE_EMPLOI: null,
  RETRAITE: null,
};

/** Placeholder du champ libre associé à chaque situation. */
export const professionalSituationDetailsPlaceholders: Record<
  ProfessionalSituationValues,
  string
> = {
  SALARIE_PRIVE: 'Ex : Google',
  FONCTION_PUBLIQUE: 'Ex : Ministère de l’Éducation nationale',
  INDEPENDANT: 'Ex : Consultant·e en informatique',
  ETUDIANT: 'Ex : Université de Nantes',
  RECHERCHE_EMPLOI: '',
  RETRAITE: '',
};

export const professionalSituationRequiresDetails = (
  situation: ProfessionalSituationValues | '' | null | undefined,
): situation is ProfessionalSituationValues =>
  !!situation && professionalSituationDetailsLabels[situation] !== null;

/** Libellé complet « Situation — détail » utilisé pour l'affichage et les exports. */
export const getProfessionalSituationLabel = (
  situation: ProfessionalSituationValues | '' | null | undefined,
  details?: string | null,
): string => {
  if (!situation) return '';
  const label = PROFESSIONAL_SITUATION[situation];
  return professionalSituationRequiresDetails(situation) && details
    ? `${label} — ${details}`
    : label;
};

export default PROFESSIONAL_SITUATION;
